module.exports = __webpack_public_path__ + "static/media/covi_phy_no_han.7fe9f8a7.png";